<template>
  <button
    type="button"
    :class="buttonClass"
    @click="openFeedbackFormModal"
  >
    質問・要望を投稿する
  </button>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import YhcServiceLevelFeedbackFormModal from './YhcServiceLevelFeedbackFormModal.vue'

export default defineComponent({
  name: 'YhcServiceLevelFeedbackSubmitButton',
  props: {
    variant: {
      type: String as PropType<'default' | 'compact'>,
      default: 'default',
      validator: (value: string) => ['default', 'compact'].includes(value),
    },
  },
  computed: {
    buttonClass(): string[] {
      const base = ['yhc-service-level-feedback-submit-btn']
      if (this.variant === 'compact') {
        return [
          ...base,
          'btn',
          'btn-sm',
          'btn-outline-secondary',
          'yhc-service-level-feedback-submit-btn--compact',
        ]
      }
      return [
        ...base,
        'btn',
        'btn-outline-primary',
        'yhc-service-level-feedback-submit-btn--default',
      ]
    },
  },
  methods: {
    openFeedbackFormModal() {
      $core.$modals.openModal({
        modalId: 'yhc-service-level-feedback-form',
        modalProps: {
          hideHeader: true,
          size: 'lg',
          centered: true,
          hideFooter: true,
          dialogClass: 'yhc-service-level-feedback-form-modal',
        },
        component: YhcServiceLevelFeedbackFormModal,
        componentProps: {
          modalId: 'yhc-service-level-feedback-form',
        },
      })
    },
  },
})
</script>

<style scoped lang="scss">
.yhc-service-level-feedback-submit-btn {
  white-space: nowrap;
  // btn-sm より通常ボタンと同じ角丸（デフォルトボタンに合わせる）
  border-radius: var(--bs-border-radius, 0.375rem);

  &--default {
    font-size: 14px;
    font-weight: 600;
    padding: 10px 16px;
  }

  &--compact {
    font-size: 12px;
    font-weight: 500;
    padding: 4px 8px;
  }
}
</style>
